import { ExpeirmentNodeProps } from 'business/models/CustomModels';
import React from 'react';
import TreeNode from './TreeNode';

export default function SeedNode(props: ExpeirmentNodeProps) {
  const node = props.data;

  const allProps = {
    ...props,
    link: `/proteins`,
  };

  function onDragStart(e, seedTreeNodeid) {
    e.dataTransfer.setData('drag_type', 'SEED_NODE');
    e.dataTransfer.setData('id', seedTreeNodeid);
  }

  return (
    <TreeNode
      key={node.id}
      {...allProps}
      draggable={true}
      onDragStart={(e) => onDragStart(e, node.id)}
    />
  );
}
